import { Image } from 'components/UI';
import { bucketUrl } from 'utils/files';
import { ThemeContext } from 'contexts';

const Logo = () => (
  <ThemeContext.Consumer>
    {(theme) =>
      theme?.headerLogo ? <Image src={`${bucketUrl}/${theme.headerLogo}`} alt="Variant Logo" h={12} /> : null
    }
  </ThemeContext.Consumer>
);

export default Logo;
